import { render, staticRenderFns } from "./TransformedInput.vue?vue&type=template&id=4c352cc9&"
import script from "./TransformedInput.vue?vue&type=script&lang=ts&"
export * from "./TransformedInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports